/** Round to 1 decimal, dropping a trailing .0 (90.769… → 90.8, 91 → 91). */
const round1 = (v) => Math.round(Number(v) * 10) / 10;

/**
 * Format values for KUROCO UI (matches prototype components.jsx).
 *
 * Rounding matches LineChart's axis formatter — 予測 rows are floats
 * (nomination_rate 90.76923076923077), so raw interpolation printed the
 * full mantissa into tooltips and scorecards.
 */
export function fmt(unit, v) {
  if (v == null || Number.isNaN(v)) return '—';
  if (unit === 'currency') return `¥${Math.round(Number(v)).toLocaleString()}`;
  if (unit === 'percent') return `${round1(v)}%`;
  if (unit === 'count') return `${Math.round(Number(v))}名`; // 人数は整数 — 23.9名 is not a thing
  if (unit === 'pieces') return `${Math.round(Number(v))}件`;
  if (unit === 'days') return `${round1(v)}日`;
  return String(v);
}

export const EM = '—';
